module.exports = __webpack_public_path__ + "img/mastercard.87cb71b.svg";